const documentTransformations = {
  numberFields: ["leadStatus", "applicationStatus"],
  timeFields: [],
  floatFields: [],
  ibanFields: [],
};

export default documentTransformations;
